// extracted by mini-css-extract-plugin
export var chevron = "_1l-d";
export var disabled = "_1l-b";
export var error = "_1l-c";
export var hideBorder = "_1l-1";
export var icon = "_1l-e";
export var input = "_1l-0";
export var large = "_1l-f";
export var open = "_1l-9";
export var placeholder = "_1l-a";
export var regular = "_1l-5";
export var singleRowInput = "_1l-2";
export var singleSelectInput = "_1l-3 _1l-0";
export var small = "_1l-4";
export var spinnerContainer = "_1l-i";
export var tag = "_1l-7";
export var tagsContainer = "_1l-8";
export var tagsInput = "_1l-6 _1l-0";
export var xSmall = "_1l-g";
export var xxSmall = "_1l-h";